
<div class="app-page" >
  <mat-toolbar>
    <!-- <button mat-raised-button (click)="selectDivisions()">
    <mat-icon>filter_alt</mat-icon>
    FILTER
  </button> &nbsp; -->

  <button mat-raised-button color="" (click)="openSetGameFilterDialog()">
    <mat-icon>filter_alt</mat-icon>
    DIVISIONS
  </button> &nbsp;
  <!-- <app-set-game-filter-dialog (divisionChanged)="getData()"></app-set-game-filter-dialog> -->

  <!-- <button mat-raised-button routerLink="/scouting/setgamefilter">
  <mat-icon>filter_alt</mat-icon>
  DIVISIONS
</button> &nbsp; -->

<!--<button mat-raised-button color="primary" (click)="openDialog()">Open Filter</button>-->

<button mat-raised-button (click)="getPastGames()">
  <mat-icon>event_repeat</mat-icon>
PAST GAMES</button>&nbsp;
<button mat-raised-button (click)="getData()">
  <mat-icon>event</mat-icon>
  COMING GAMES
</button>&nbsp;
<mat-button-toggle-group [(ngModel)]="GroupByPropertyName" value="GameDate'">
  <mat-button-toggle value="GameTimeUTC">My timezone</mat-button-toggle>
  <mat-button-toggle value="GameDate">Local timezones</mat-button-toggle>
</mat-button-toggle-group>

</mat-toolbar>
@if (this.isBusy) {
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
}
@if (this._pageData?.Games.length==0) {
  <div style="font-family: Roboto; margin: 20px;;">
    NO GAMES FOUND
  </div>
}
<label>{{this.GroupByPropertyName}}</label>
@if (this._pageData) {
  @for (group of this._pageData.Games | groupByDateProperty: this.GroupByPropertyName; track group) {
    <div style="margin-left: 20px;">
      <app-date-divider [Date]="group.GroupDate"></app-date-divider>
    </div>
    @if (this._pageData) {
      <div style="display: flex; flex-direction: row; flex-wrap: wrap;margin-left: 20px;">
        @for (game of group.Games; track game ) {
          <div>
            <app-game-card [Game]="game" [ShowDate]="false" [DateDisplay]="this.GroupByPropertyName"
              (removeEvent)="removeFromSchedule($event)"
            (openAddEvent)="addToSchedule1($event, game.HomeTeamName, game.AwayTeamName, game.GameDate, game.GameTime)"></app-game-card>
          </div>
        }
      </div>
    }
  }
}


</div>

